import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./tooltip-bubble.module.scss";

const TooltipForm = ({
  content,
  children,
  disabled = false,
  visible: controlledVisible,
  placement = "center", // "center" or "left"
}) => {
  const [hoverVisible, setHoverVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  const handleMouseEnter = () => {
    if (!disabled) setHoverVisible(true);
  };

  const handleMouseLeave = () => {
    if (!disabled) setHoverVisible(false);
  };

  // Use controlled visible if provided, else fallback to hover
  const isVisible = typeof controlledVisible === "boolean" ? controlledVisible : hoverVisible;

  useEffect(() => {
    if (isVisible && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const leftPosition =
        placement === "center"
          ? rect.left + rect.width / 2 + window.scrollX
          : rect.left + window.scrollX;

      setPosition({
        top: rect.bottom + window.scrollY + 8,
        left: leftPosition,
      });
    }
  }, [isVisible, placement]);

  return (
    <>
      <div
        ref={wrapperRef}
        className={styles.tooltipWrapper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {isVisible &&
        !disabled &&
        createPortal(
          <div
            className={`${styles.tooltipContainer} ${
              placement === "left" ? styles.alignLeft : styles.alignCenter
            }`}
            style={{
              position: "absolute",
              top: `${position.top}px`,
              left: `${position.left}px`,
              transform: placement === "center" ? "translateX(-50%)" : "none",
            }}
          >
            <span
              className={`${styles.tooltipArrow} ${
                placement === "left" ? styles.arrowLeft : styles.arrowCenter
              }`}
            />
            <div className={styles.tooltipBubble}>{content}</div>
          </div>,
          document.body
        )}
    </>
  );
};

export default TooltipForm;
